import IdqsOpenOrderPage from './IdqsOpenOrderPage';
export { IdqsOpenOrderPage };
export default IdqsOpenOrderPage;
